import { GetterTree } from "vuex";
import { HomeState, RootState } from "@/types/home";

const getters: GetterTree<HomeState, RootState> = {
  getRecommendRecipes: (state: HomeState) => {
    return state.recommendRecipes;
  },
  getRankingRecipes: (state: HomeState) => {
    return state.rankingRecipes;
  },
  getBannerPosition: (state: HomeState) => {
    return state.bannerPosition;
  },
  getBanners: (state: HomeState) => {
    return state.banners;
  },
  getInformationServices: (state: HomeState) => {
    return state.services;
  },
  getRecentMyList: (state: HomeState) => {
    return state.recentMyList;
  },
  getMyList: (state: HomeState) => {
    return state.myList;
  },
  getFoodRecommendationList: (state: HomeState) => {
    return state.foodRecommendationList;
  },
  getOneMenuRecommendation: (state: HomeState) => {
    return state.oneMenuRecommendation;
  },
};

export default getters;
